import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import { Panel } from '../../components/primitives/Panel';
import { Cover } from '../../components/primitives/Cover';
import { IntegrationTypeIcon } from '../../components/IntegrationTypeIcon';
import type { BrowsePlaylistItem } from '../hooks/useBrowseSearch';
import { browseMessages as messages } from '../browseMessages';
import { BrowseCostChip } from './BrowseCostChip';
import { BrowseFollowButton } from './BrowseFollowButton';
import { BrowseOpenLink } from './BrowseOpenLink';
/* eslint-disable css-modules/no-unused-class -- a shared stylesheet; each part uses its own slice of it */
import styles from './BrowseRows.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface BrowsePlaylistCardProps {
  playlist: BrowsePlaylistItem;
}

/** One playlist card in the Playlists panel (design a1). Opening a playlist is free (owner answer 1). */
const BrowsePlaylistCardComponent: React.FC<BrowsePlaylistCardProps> = ({ playlist }) => {
  const intl = useIntl();

  return (
    <Panel nested className={styles.playlistCard} data-testid="browse-playlist-card">
      <BrowseOpenLink kind="playlist" id={playlist.id} state={playlist.state} className={styles.nameCell}>
        <Cover src={playlist.imageUrl} label={playlist.name} size={56} radius={10} />
        <span className={styles.nameMain}>{playlist.name}</span>
        <span className={styles.nameSub}>
          <span className={styles.serviceLine}>
            <IntegrationTypeIcon integrationType={playlist.service} size={12} />
            {playlist.curatorName ?? playlist.service}
          </span>
        </span>
      </BrowseOpenLink>
      <div className={styles.playlistMeta}>
        <span>
          {playlist.followers === null
            ? '—'
            : intl.formatMessage(messages.playlistFollowers, { count: playlist.followers })}
        </span>
        <span>
          {playlist.songs === null ? '' : intl.formatMessage(messages.playlistSongs, { count: playlist.songs })}
        </span>
      </div>
      <div className={styles.playlistFoot}>
        <BrowseCostChip state={playlist.state} />
        <BrowseFollowButton
          kind="playlist"
          id={playlist.id}
          name={playlist.name}
          followed={playlist.state === 'followed'}
        />
      </div>
    </Panel>
  );
};

export const BrowsePlaylistCard = TypedMemo(BrowsePlaylistCardComponent);
